import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { timestamp } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
const orignalsourcename = "S011"



/*
  Generated class for the CommonProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CommonProvider {
  deviceTypePayment =  "WEBSH2";
  //"ANDROIDSH1" or "ANDROIDSH2" , "iOSSH1" or "iOSSH2", "WEBSH1" or "WEBSH2"
  VERSION:any="4.1.6";
  PLATFORM:any="WEB";
  //commonApiUrl:any="https://preprodapi.sammaancapital.com:5000";
  commonApiUrl:any="https://prodapi.sammaancapital.com";
   // commonApiUrl:any="https://prodapi.indiabullshomeloans.com";
   // commonApiUrl:any="https://preprodapi.sammaancapital.com:5000";
  // commonApiUrl:any="https://prodapi.indiabullshomeloans.com";

   httpOptions:any={}
   httpOptions1:any={}
   
  constructor(public http: HttpClient) {
    this.httpOptions = {
        headers: new HttpHeaders(
          { 'Authorization': localStorage.getItem("token")?localStorage.getItem("token") :"" },
          )
    };
    this.httpOptions1 = {
      headers: new HttpHeaders(
        { 'Authorization': localStorage.getItem("token")?localStorage.getItem("token") :"" ,'content-type': "application/json" },
        )
    };
  }

 async getAboutUsPage(loader){

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    internalJson.code = '01008';

    //var rand =  Math.floor((Math.random() * 100) + 1);
    const dataKeyy: any = await this.getIVKeySession(loader);
    
    let dataKey = JSON.parse(dataKeyy); 
    var key =  dataKey.Payload.key.toString(CryptoJS.enc.Hex);
    var iv =  dataKey.Payload.iv.toString(CryptoJS.enc.Hex);
    const encrypted = AES.encrypt(JSON.stringify(internalJson), key,{
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    const payload = {
      key: key.toString(CryptoJS.enc.Hex),
      iv: iv.toString(CryptoJS.enc.Hex),
      data: encrypted.toString() // Base64
    }; 
     
    //body.inputstring = btoa(rand.toString())+"~"+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/knowledgearticles",JSON.stringify(payload),this.httpOptions1).subscribe((data:any) => {
         
        var data1 = CryptoJS.AES.decrypt(data.outputstring, key.toString(CryptoJS.enc.Hex))
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);

      }, err => {
        loader.dismiss()
        

      });
    });

    
  }
  checkCaptcha(captcha, user_captcha) {
        return captcha.localeCompare(user_captcha) == 0;
    };

  generatecp () {
        // Characters to be included
        const chrs = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let captcha = "";
        for (let i = 0; i < 6; i++) {
        captcha += chrs[(Math.floor(Math.random() * chrs.length))];
        }
        sessionStorage.setItem("code",captcha)
        return captcha;
        // var _this = this;
        // var body = request;
        // return new Promise(function (resolve) {
        //     _this.http.post(_this.commonApiUrl + "/generateCaptcha", JSON.stringify(body), _this.httpOptions1).subscribe(function (data) {
        //         resolve(data);
        //     }, function (err) {
        //         loader.dismiss();
        //     });
        // });
    };  
  getOffersPage(loader){

    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    
    internalJson.code = '01005';

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/knowledgearticles",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        
        resolve(newData);
      }, err => {
        loader.dismiss()
        
      });
    });    
  }
  getRefferAfriendPage(loader){

    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    
    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/products",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });

    
  }
  async postFaq(loader,request){
    
    let body:any={};
    //body.inputstring="";
    let internalJson:any={};
    
    internalJson.body = request;
    const dataKeyy: any = await this.getIVKeySession(loader);
    
    let dataKey = JSON.parse(dataKeyy); 
    var key =  dataKey.Payload.key.toString(CryptoJS.enc.Hex);
    var iv =  dataKey.Payload.iv.toString(CryptoJS.enc.Hex);
    const encrypted = AES.encrypt(JSON.stringify(internalJson), key,{
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    // body = {
    //   key: key.toString(CryptoJS.enc.Hex),
    //   iv: iv.toString(CryptoJS.enc.Hex),
    //   data: encrypted.toString() // Base64
    // }; 

    body = {
      //key: key.toString(CryptoJS.enc.Hex),
      //iv: iv.toString(CryptoJS.enc.Hex),
      uniqueKey:dataKey.Payload.UniqueID,
      data: encrypted.toString() // Base64
    };
    
    //body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/faq_post",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        
        var data1 = CryptoJS.AES.decrypt(data.outputstring, key.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
  getPersonalInfo(loader,customercode){
    customercode = JSON.parse(localStorage.getItem("existingLoan"))[0].customercode
    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    internalJson.customercode = customercode;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/contacts",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        
        resolve(newData);
      }, err => {
        loader.dismiss()
        

      });
    });
  }
  //
  getOtherProductPage(loader){


    // var url = this.finOneApiUrl+'/knowledgearticles?include=content,title,ibhfl_code&ibhfl_code=01001'
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.code = '01001';
    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/knowledgearticles",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });

  }
  getSrHistory(loader,categorycode,customercode){
    customercode = JSON.parse(localStorage.getItem("existingLoan"))[0].customercode
     
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    internalJson.categorycode = categorycode;
    internalJson.customercode = customercode;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/serviceRequestHistory",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
         
      });
    });
  }
  getCasetypesComplaint(loader,categorycode){

    // var url = this.srHistoryUrl+"getCasetypesComplaint?categorycode="+categorycode
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    internalJson.categorycode = categorycode;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/getCasetypesComplaint",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });

  }
  getSubCasetypesComplaint(loader,categorycode){

     // var url = this.srHistoryUrl+"getCasesubtypesComplaint?casetypecode="+categorycode
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    internalJson.categorycode = categorycode;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/getCasesubtypesComplaint",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

  
  getForClousreCategory(loader){

    //retentiondetails?subtypecode=ST201&statecode=0

    // var url = this.srHistoryUrl+"retentiondetails?subtypecode=ST201&statecode=0"
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/retentiondetails",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
 
  
  async getDailingCodeAllCountries(loader) {
    // var url = this.finOneApiUrl+'/ibhfl_countrydialingcodes?statecode=0&orderby=ibhfl_ordernumber'
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;

    //var rand =  Math.floor((Math.random() * 100) + 1);
    const dataKeyy: any = await this.getIVKeySession(loader);
    
    let dataKey = JSON.parse(dataKeyy); 
    var key =  dataKey.Payload.key.toString(CryptoJS.enc.Hex);
    var iv =  dataKey.Payload.iv.toString(CryptoJS.enc.Hex);
    const encrypted = AES.encrypt(JSON.stringify(internalJson), key,{
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    body = {
      //key: key.toString(CryptoJS.enc.Hex),
      //iv: iv.toString(CryptoJS.enc.Hex),
      uniqueKey:dataKey.Payload.UniqueID,
      data: encrypted.toString() // Base64
    }; 
    
     
    //body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/dailingcountrycode",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, key.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
  getRelationships(loader) {
    // var url = this.finOneApiUrl+'/ibhfl_countrydialingcodes?statecode=0&orderby=ibhfl_ordernumber'
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/coapplicantRelationshipMaster",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

  
  // checkExistingUser(loader,mobileNumber){
    
  //   // var url = this.contactManagementApiUrl+'contact?mobilephone='+mobileNumber
  //   // 


  //   let body:any={};
  //   body.inputstring="";
  //   let internalJson:any={};
  //   internalJson.mobileNumber = mobileNumber;
  //   // internalJson.header=JSON.stringify(this.httpOptions1)
  //   // //console.log(internalJson)
  //   var rand =  Math.floor((Math.random() * 100) + 1);
  //   // var encrypted = CryptoJS.AES.encrypt("myString", rand.toString()).toString()
  //   // //console.log(encrypted);
  //   // //console.log( CryptoJS.AES.encrypt("abc",rand.toString()).toString());
  //   body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
  //   // //console.log(CryptoJS.AES.decrypt(CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()), rand.toString()).toString(CryptoJS.enc.Utf8))

  //   return new Promise(resolve => {
  //     this.http.post(this.commonApiUrl+"/checkusername",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
  //        // //console.log(rand.toString(),data.outputstring);
  //       var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
  //       var newData =  data1.toString(CryptoJS.enc.Utf8);
  //       // //console.log(newData);
  //       resolve(newData);
  //     }, err => {
  //       loader.dismiss()
  //       // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
  //     });
  //   });
  // }
  // doLogin(loader,mobileNumber,password){
  //   // //console.log(mobileNumber);
  //    // password = "Password12@"
  //   // var url = this.authenticatempinUrl+'authpass?ccs_mobilenumber='+mobileNumber+'&ibhfl_password='+password;
  //   // //console.log(url)
  //   let body:any={};
  //   body.inputstring="";
  //   let internalJson:any={};
  //   internalJson.mobileNumber = mobileNumber;
  //   internalJson.password = password;

  //   internalJson.header=JSON.stringify(this.httpOptions1)
  //   // //console.log(internalJson)
  //   var rand =  Math.floor((Math.random() * 100) + 1);
  //   // var encrypted = CryptoJS.AES.encrypt("myString", rand.toString()).toString()
  //   // //console.log(encrypted);
  //   // //console.log( CryptoJS.AES.encrypt("abc",rand.toString()).toString());
  //   body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
  //   //console.log(body.inputstring)
  //   return new Promise(resolve => {
  //     this.http.post(this.commonApiUrl+"/login",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         
  //      var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
  //      var newData =  data1.toString(CryptoJS.enc.Utf8);
       
  //      newData =JSON.parse(newData);
       
  //      newData.accesstoken = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(newData.accesstoken, rand.toString());;
  //      newData =JSON.stringify(newData);
  //       resolve(newData);
  //     }, err => {
  //       loader.dismiss()
  //       // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
  //     });
  //   });
  // }
  async checkExistingUser(loader,mobileNumber,check:any=true){
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    if(check){
      internalJson.mobileNumber = mobileNumber;
    }else{
      internalJson.CIF = mobileNumber;
    }
    
    internalJson.captcha = sessionStorage.getItem("code"); 
    
    //var rand =  Math.floor((Math.random() * 100) + 1);

    const dataKeyy: any = await this.getIVKeySession(loader);
    
    let dataKey = JSON.parse(dataKeyy); 
    var key =  dataKey.Payload.key.toString(CryptoJS.enc.Hex);
    var iv =  dataKey.Payload.iv.toString(CryptoJS.enc.Hex);
    const encrypted = AES.encrypt(JSON.stringify(internalJson), key,{
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    body = {
      //key: key.toString(CryptoJS.enc.Hex),
      //iv: iv.toString(CryptoJS.enc.Hex),
      uniqueKey:dataKey.Payload.UniqueID,
      data: encrypted.toString() // Base64
    }; 
     
    //body.inputstring = btoa(rand.toString())+'~'+AES.encrypt(JSON.stringify(internalJson), rand.toString());
     

    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/checkusername",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = AES.decrypt(data.outputstring, key.toString())
        var newData =  data1.toString(Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
         
      });
    });
  }
 async doLogin(loader,mobileNumber,password,check:any=true){
     
    let body:any={};
    //body.inputstring="";
    let internalJson:any={};
    if(check){
      internalJson.mobileNumber = mobileNumber;
    }else{
      internalJson.CIF = mobileNumber;
    }
    
    internalJson.password = password;
    internalJson.captcha = sessionStorage.getItem("code");

    internalJson.header=JSON.stringify(this.httpOptions1)
    // //console.log(internalJson)
    //var rand =  Math.floor((Math.random() * 100) + 1);
    const dataKeyy: any = await this.getIVKeySession(loader);
    
    let dataKey = JSON.parse(dataKeyy); 
    var key =  dataKey.Payload.key.toString(CryptoJS.enc.Hex);
    var iv =  dataKey.Payload.iv.toString(CryptoJS.enc.Hex);
    const encrypted = AES.encrypt(JSON.stringify(internalJson), key,{
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    body = {
      //key: key.toString(CryptoJS.enc.Hex),
      //iv: iv.toString(CryptoJS.enc.Hex),
      uniqueKey:dataKey.Payload.UniqueID,
      data: encrypted.toString() // Base64
    }; 
    //body.inputstring = btoa(rand.toString())+'~'+AES.encrypt(JSON.stringify(internalJson), rand.toString());
    //console.log(body.inputstring)
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/login",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         
       var data1 = AES.decrypt(data.outputstring, key.toString())
       var newData =  data1.toString(Utf8);

        resolve(newData);
      }, err => {
        loader.dismiss()
         
      });
    });
  } 
  generateToken(loader,lan){
     

    let body1:any = {};
    body1.UserId = "API_USER";
    body1.LAN = lan;
    body1.Password = "ibulls@123";
    // var url = this.tokenGenUrl+'GenerateTokenDisha'
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/GenerateTokenDisha",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
  verifyOtp(loader,otp,mobile_number){


     
     let body1:any = {};
    body1.mobile_number = mobile_number
    body1.OTP = otp;
    // var url = this.otpValidationApiUrl+'valOtp'
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    //console.log(body.inputstring)
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/verifyotp",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         
       var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
       var newData =  data1.toString(CryptoJS.enc.Utf8);
       
       newData =JSON.parse(newData);
       newData =JSON.stringify(newData);
       resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
  enquiryAbout(loader,str_acc_no,str_userid,token){
   
    let body1:any = {};
    body1.str_userid = str_userid
    body1.str_acc_no = str_acc_no
    // {"str_acc_no":"HHLBAG00288927","str_userid":"9987074887"}
     let httpOptionsWithtoken = {
      headers: new HttpHeaders(
        { 'Authorization': '',"token":token },
        )
    };
    // var url = this.enAboutUrl+'enquiryAboutRequest'

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/enquiryAboutRequest",JSON.stringify(body),httpOptionsWithtoken).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }


  newPartPayment(loader,str_acc_no,str_userid,token){
    
    let body1:any = {};
    body1.UserId = str_userid
    body1.LanAccNumber = str_acc_no
     
    // {"str_acc_no":"HHLBAG00288927","str_userid":"9987074887"}
    let httpOptionsWithtoken = {
      headers: new HttpHeaders(
        { 'Authorization': '',"token":token },
        )
    };
    // var url = this.enPartUrl+'emipartpayment'

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/emipartpayment",JSON.stringify(body),httpOptionsWithtoken).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });

    
  }  

//Paytm Payment Api

  newPaytmPayment(loader,orderId,amount){
    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.orderId = orderId;
    internalJson.amount = amount;
    internalJson.customerId = "CUST_"+JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;
    // internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/generateTokenPaytmWeb",JSON.stringify(body),this.httpOptions).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
    
    
  }

  verifyStatusPaytmPayment(loader,orderId){
    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.orderId = orderId;
    // internalJson.amount = amount;
    // internalJson.customerId = "CUST_"+JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;
    // internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/transcationStatusPaytm",JSON.stringify(body),this.httpOptions).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
    
    
  }

  newPaytmPaymentChecksumHash(loader){
    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/tokenPaytm",JSON.stringify(body),this.httpOptions).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        // var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        // var newData =  data1.toString(CryptoJS.enc.Utf8);
        var newData =  data;
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
    
    
  }  

//***************************************************

  //enquiryAboutRequest
  generateOtp(loader,mobileNumber){
    //console.log(mobileNumber);
    let body1:any = {};
    body1.mobile_number = mobileNumber
     
    // var url = this.generateOtpApiUrl+'genOtp'


    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/genOtp",JSON.stringify(body),this.httpOptions).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

  generateMobileEmailOtp(loader,mobileNumber,email){
    //console.log(mobileNumber);
    let body1:any = {};
    body1.mobile_number = mobileNumber
    body1.email = email 
    // var url = this.generateOtpApiUrl+'genOtp'


    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/genOtp",JSON.stringify(body),this.httpOptions).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

  generateEmailOtp(loader,email){
    //console.log(email);
    let body1:any = {};
    body1.email = email
     
    // var url = this.generateOtpApiUrl+'genOtp'
    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/genOtp",JSON.stringify(body),this.httpOptions).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
     
  }
  postCancelMandate(loader,request){
    let body1:any = {};
      
      body1=request
       
      let body:any={};
      body.inputstring="";
      let internalJson:any={};
      // internalJson.url = url;
      body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
      internalJson.body = body1;
      var rand =  Math.floor((Math.random() * 100) + 1);
      body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
      return new Promise(resolve => {
        this.http.post(this.commonApiUrl+"/mandatecancellationsr",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
           // //console.log(rand.toString(),data.outputstring);
          var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
          var newData =  data1.toString(CryptoJS.enc.Utf8);
            
          resolve(newData);
        }, err => {
          loader.dismiss()
          // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
        });
      });
    
  }
  getCancelMandateByLan(loader,ibhfl_name){
    
    let body1:any = {};
    body1.transactionId = Date.now();
    body1.LAN = ibhfl_name
     
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/accountcancellationsrdetails",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
          
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
  getDashBoardApiData(loader,ibhfl_name,customer_code){
    
    let body1:any = {};
    body1.transactionId = Date.now();
    body1.loanAgreementNo = ibhfl_name
    body1.cifId = customer_code
    // var url = this.dashboardApiUrl+'LoanAndPersonaldetails'
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/LoanAndPersonaldetails",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
          
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
  getDashBoardTrancheAndBankDetailsApiData(loader,ibhfl_name,customer_code){
    
    // let body:any = {};
    // body.transactionId = Date.now();
    // body.loanAgreementNo = ibhfl_name
    let body1:any = {};
    body1.transactionId = Date.now();
    body1.loanAgreementNo = ibhfl_name
    // body1.cifId = customer_code
    // var url = this.dashboardApiUrl+'LoanAndPersonaldetails'
    // var url = this.dashboardApiUrl+'TrancheAndBankDetails'
    

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    // internalJson.header=JSON.stringify(this.httpOptions1)
    // //console.log(internalJson)
    var rand =  Math.floor((Math.random() * 100) + 1);
    // var encrypted = CryptoJS.AES.encrypt("myString", rand.toString()).toString()
    // //console.log(encrypted);
    // //console.log( CryptoJS.AES.encrypt("abc",rand.toString()).toString());
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    // //console.log(CryptoJS.AES.decrypt(CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()), rand.toString()).toString(CryptoJS.enc.Utf8))

    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/TrancheAndBankDetails",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

  postRaiseQuery(loader,ccs_casecategory,ccs_remarks,customerid,ccs_casetype,
                  ibhfl_loanaccountnumber1,ccs_originatingsource,
                  ccs_casesubtype)
  {
                    
    let body1:any = {};
    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    body1.ccs_casecategory = ccs_casecategory;
    body1.ccs_remarks = ccs_remarks
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;// customerid;
    body1.ccs_casedescription = "Create Complaint Case for "+ccs_casetype+" ---> "+ccs_casesubtype;

    body1.ccs_casetype = ccs_casetype;
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1
    body1.ccs_originatingsource = orignalsourcename;
    body1.ccs_casesubtype = ccs_casesubtype
    
     
    // var url = this.raisedCaseUrl+'complaint'

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/complaint",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
     }

//Generate Forclousre

 

 postEditAddressSr(loader,ccs_remarks,ccs_remarksaddress,customerid,ibhfl_loanaccountnumber1,
  ibhfl_countrycode,ibhfl_customername,ibhfl_city,ibhfl_pincode,
  ibhfl_state,ibhfl_role,ibhfl_phone1,ibhfl_phone2,ibhfl_newmobileno,ibhfl_newemailid,ibhfl_addressline4,
  ibhfl_typeofrectificationrequired,ibhfl_stdcode,ibhfl_addresstypes)
 {
    
    let body1:any = {};
    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    body1.ccs_casecategory = "CC03";
    body1.ccs_remarks = ccs_remarks
    body1.ccs_remarksaddress = ccs_remarksaddress
    
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;;
    body1.ccs_casedescription = "Create case for communication update Rectify Address";

    body1.ccs_casetype = "CT33";
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1;
    body1.ccs_originatingsource =orignalsourcename;
    body1.ccs_casesubtype = "ST02"

    body1.ibhfl_countrycode = ibhfl_countrycode
    body1.ibhfl_customername = ibhfl_customername
    body1.ibhfl_city = ibhfl_city
    // body1.ibhfl_pincode = ibhfl_pincode
    body1.ibhfl_state = ibhfl_state
    body1.ibhfl_role = ibhfl_role
    body1.ibhfl_phone1 = ibhfl_phone1
    body1.ibhfl_phone2 = ibhfl_phone2
    body1.ibhfl_newmobileno = ibhfl_newmobileno
    body1.ibhfl_newemailid = ibhfl_newemailid

    
    body1.ibhfl_addressline4 = ibhfl_addressline4
    body1.ibhfl_typeofrectificationrequired = ibhfl_typeofrectificationrequired
    body1.ibhfl_stdcode = ibhfl_stdcode
    body1.ibhfl_addresstypes=ibhfl_addresstypes
    //console.log("Edit Change",body1);
    // var url = this.raisedCaseUrl+'AddressChange'

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/AddressChange",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
 }
 getFinancialYear(loader) {
    // var url = this.finOneApiUrl+'/ibhfl_countrydialingcodes?statecode=0&orderby=ibhfl_ordernumber'
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/GetfinacialYear",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
 }
  postRetforclosure(loader,ccs_casecategory,ccs_remarks,customerid,ccs_casetype,
  ibhfl_loanaccountnumber1,ccs_originatingsource,
  ccs_casesubtype,reason,SRType){
    var date = new Date();
    var dateY=date.getFullYear()
    var pdateY=(date.getFullYear()-1)
    let body1:any = {};
     
    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    body1.ConsumerSystemName = "RelevantSystemName";
    if(SRType!='SOA'){
      body1.SRType = SRType;
    }
    
     
    body1.ccs_casecategory = ccs_casecategory;
    body1.ccs_remarks = ccs_remarks
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;;
    body1.ccs_casedescription = "Create Case for Generation "+SRType+" " +ccs_casetype+" ---> "+ccs_casesubtype;
    body1.ccs_casetype = ccs_casetype;
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1
    body1.ccs_originatingsource = orignalsourcename;
    body1.ccs_casesubtype = ccs_casesubtype
    if(SRType!="RepaymentSchedule"){
      body1.ibhfl_reasonfordocumentrequested = reason
    }
    
    body1.ibhfl_dateofrequestletter = pdateY+"-03-01"
    body1.ibhfl_retention = "true"
    body1.ibhfl_pmay = "false"
    body1.ibhfl_createcaseafd = "false"

    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/createDocumentSR",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

  //Generate Interest Certificates

  

  postInterestCertificates(loader,ccs_casecategory,ccs_remarks,customerid,ccs_casetype,
  ibhfl_loanaccountnumber1,ccs_originatingsource,
  ccs_casesubtype,reason){
    
    let body1:any = {};
    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    var date = reason.split("-");//new Date();

    var dateY= date[1];//date.getFullYear()
    var pdateY=date[0];//(date.getFullYear()-1)
    body1.ccs_casecategory = ccs_casecategory;
    body1.ccs_remarks = "Service request for Interest Certificate"
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;;
    // body.ccs_casedescription = "Create Complaint Case for "+ccs_casetype+" ---> "+ccs_casesubtype;

    body1.ccs_casetype = ccs_casetype;
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1
    body1.ccs_originatingsource = orignalsourcename;
    body1.ccs_casesubtype = ccs_casesubtype;
    body1.ibhfl_periodfrom = pdateY+"-04-01"
    body1.ibhfl_periodto = dateY+"-03-31"

    // var url = this.raisedCaseUrl+'InterestCertificate';

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/InterestCertificate",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

//Bounce Memo request

   postBounceMemo(loader,ccs_casecategory,ccs_remarks,customerid,ccs_casetype,
  ibhfl_loanaccountnumber1,ccs_originatingsource,
  ccs_casesubtype,from_date,to_date){
    
    let body1:any = {};
    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    body1.ccs_casecategory = ccs_casecategory;
    body1.ibhfl_bounsmemoremarks = "Bounce Memo Details"
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;;
    body1.ccs_casedescription = "Create case for Bounce Memo Request";

    body1.ccs_casetype = ccs_casetype;
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1
    body1.ccs_originatingsource = orignalsourcename;
    body1.ccs_casesubtype = ccs_casesubtype;
    body1.ibhfl_periodfrom = from_date
    body1.ibhfl_periodto = to_date


     

    // var url = this.raisedCaseUrl+'BounceMemoRequest'

     let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/BounceMemoRequest",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

// Generate Welcome Letter

  postWelcomeLetter(loader,ccs_casecategory,ccs_remarks,customerid,ccs_casetype,
  ibhfl_loanaccountnumber1,ccs_originatingsource,
  ccs_casesubtype){
    
    let body1:any = {};
    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    body1.ccs_casecategory = ccs_casecategory;
    body1.ccs_remarks = "Welcome Letter"
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;;
    // body.ccs_casedescription = "Create Complaint Case for "+ccs_casetype+" ---> "+ccs_casesubtype;

    body1.ccs_casetype = "CT22";
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1
    body1.ccs_originatingsource = orignalsourcename;
    body1.ccs_casesubtype = "ST204";
    // var url = this.raisedCaseUrl+'WelcomeLetter'

     let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/WelcomeLetter",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
     
  }

//SR create for mobile number
postContactDetailsUpdateQuery(loader,ccs_casecategory,ccs_remarks,customerid,ccs_casetype,
  ibhfl_loanaccountnumber1,ccs_originatingsource,
  ccs_casesubtype,ibhfl_customername,ibhfl_typeofcontactupdate,ibhfl_newmobileno){
    
    let body1:any = {};

    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    body1.ccs_casecategory = ccs_casecategory;
    body1.ccs_casetype = ccs_casetype;
    body1.ccs_casesubtype = ccs_casesubtype
    body1.ccs_remarks = ccs_remarks
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;;
    body1.ccs_originatingsource = orignalsourcename;
    body1.ccs_casedescription = "Create Complaint Case for "+ccs_casetype+" ---> "+ccs_casesubtype;
    body1.ibhfl_customername=ibhfl_customername;
    body1.ibhfl_typeofcontactupdate=ibhfl_typeofcontactupdate;
    body1.ibhfl_newmobileno=ibhfl_newmobileno;

    // var url = this.raisedCaseUrl+'ContactDetailsUpdation'

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/ContactDetailsUpdation",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });

  }  

  //SR create for ladline number
postContactDetailsUpdateLadlineQuery(loader,ccs_casecategory,ccs_remarks,customerid,ccs_casetype,
  ibhfl_loanaccountnumber1,ccs_originatingsource,
  ccs_casesubtype,ibhfl_customername,ibhfl_typeofcontactupdate,ibhfl_newmobileno,ibhfl_stdcode,ibhfl_addresstypes){
    
    let body1:any = {};

    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    body1.ccs_casecategory = ccs_casecategory;
    body1.ccs_casetype = ccs_casetype;
    body1.ccs_casesubtype = ccs_casesubtype
    body1.ccs_remarks = ccs_remarks
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;;
    body1.ccs_originatingsource = orignalsourcename;
    body1.ccs_casedescription = "Create Complaint Case for "+ccs_casetype+" ---> "+ccs_casesubtype;
    body1.ibhfl_customername=ibhfl_customername;
    body1.ibhfl_typeofcontactupdate=ibhfl_typeofcontactupdate;
    body1.ibhfl_newlandlineno=ibhfl_newmobileno;
    body1.ibhfl_stdcode=ibhfl_stdcode;
    body1.ibhfl_addresstypes=ibhfl_addresstypes;
    // var url = this.raisedCaseUrl+'ContactDetailsUpdation'

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    //console.log(internalJson); 
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/ContactDetailsUpdation",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });

  }  
//Create Request for Update Official Email
postContactDetailsUpdateEmailQuery(loader,ccs_casecategory,ccs_remarks,customerid,ccs_casetype,
  ibhfl_loanaccountnumber1,ccs_originatingsource,
  ccs_casesubtype,ibhfl_customername,ibhfl_typeofcontactupdate,ibhfl_newemailid,ibhfl_addresstypes,
  ccs_communicationaddress){
    
    let body1:any = {};

    body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    body1.ccs_casecategory = ccs_casecategory;
    body1.ccs_casetype = ccs_casetype;
    body1.ccs_casesubtype = ccs_casesubtype
    body1.ccs_remarks = ccs_remarks
    body1.ibhfl_loanaccountnumber1 = ibhfl_loanaccountnumber1
    body1.customerid =JSON.parse(localStorage.getItem("existingLoan"))[0].customercode;;
    body1.ccs_originatingsource = orignalsourcename;
    body1.ccs_casedescription = "Create case for Contact Details Updation";
    body1.ibhfl_customername=ibhfl_customername;
    body1.ibhfl_typeofcontactupdate=ibhfl_typeofcontactupdate;
    body1.ibhfl_newemailid=ibhfl_newemailid;
    body1.ibhfl_addresstypes=ibhfl_addresstypes;
    body1.ccs_communicationaddress=ccs_communicationaddress;
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/ContactDetailsUpdation",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });

  }   

getODChargesDetails(loader,ibhfl_name,customer_code){
  var date = new Date();
  var dateY=date.getFullYear()
  var dateM=date.getMonth();
  var dateD = date.getDate();
  var month_names_short = [
    'Jan',
    'Feb', 
    'Mar', 
    'Apr', 
    'May', 
    'Jun', 
    'Jul', 
    'Aug', 
    'Sep', 
    'Oct', 
    'Nov', 
    'Dec']
  var gatMon = month_names_short[dateM];
  var fullDate ="";
  if(dateD<10){
     fullDate ="0"+dateD+'-'+gatMon+'-'+dateY;
  }else{
     fullDate = dateD+'-'+gatMon+'-'+dateY;
  }
  
  //console.log("date full",fullDate);
  var previousSixMon = ((dateM)-6);
  var previousY =0;
  var getPreviousMon = 0
  if(previousSixMon < 0){
    previousY = dateY-1;
    getPreviousMon =  12+previousSixMon
  }else{
    previousY = dateY;
    getPreviousMon =  previousSixMon
  }
  var gatPreMon = month_names_short[getPreviousMon];
   
  var beforeSixMonthDate ='01'+'-'+gatPreMon+'-'+previousY;
  let body1:any = {
  "loanAgreementNo":ibhfl_name,
  "toDate":fullDate,"crmSrNumber":customer_code,
  "transactionId":Date.now(),
  "fromDate":beforeSixMonthDate,
  "requestFiller9":"",
  "requestFiller7":"",
  "requestFiller8":"",
  "requestFiller1":"",
  "requestFiller2":"",
  "requestFiller10":"",
  "requestFiller5":"",
  "requestFiller6":"",
  "requestFiller3":"",
  "requestFiller4":""
  };

    // var url = this.dashboardApiUrl+'ODChargesDetails'
    

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    // //console.log(CryptoJS.AES.decrypt(CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()), rand.toString()).toString(CryptoJS.enc.Utf8))

    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/ODChargesDetails",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });

}


  getDashBoardEmiPMiApiData(loader,ibhfl_name,customer_code){
    var date = new Date();
    var dateY=date.getFullYear()
    var dateM=date.getMonth();
    var dateD = date.getDate();
    var month_names_short = [
      'Jan',
      'Feb', 
      'Mar', 
      'Apr', 
      'May', 
      'Jun', 
      'Jul', 
      'Aug', 
      'Sep', 
      'Oct', 
      'Nov', 
      'Dec']
    var gatMon = month_names_short[dateM];
    if(dateD<10){
      var fullDate = "0"+dateD+'-'+gatMon+'-'+dateY;
    }else{
      var fullDate = dateD+'-'+gatMon+'-'+dateY;
    }
    
    console.log("date full",fullDate);
    var previousSixMon = ((dateM)-6);
    var previousY =0;
    var getPreviousMon = 0
    if(previousSixMon < 0){
      previousY = dateY-1;
      getPreviousMon =  12+previousSixMon
    }else{
      previousY = dateY;
      getPreviousMon =  previousSixMon
    }
    var gatPreMon = month_names_short[getPreviousMon];
    var preDay = new Date(previousY, (getPreviousMon+1), 0).getDate()
    
    
    var beforeSixMonthDate = '01'+'-'+gatPreMon+'-'+previousY;
    //console.log("date full",preDay);
    //console.log("date previos",beforeSixMonthDate);
    let body:any = {
    "loanAgreementNo":ibhfl_name,
    "toDate":fullDate,"crmSrNumber":customer_code,
    "transactionId":Date.now(),
    "fromDate":beforeSixMonthDate,
    "requestFiller9":"",
    "requestFiller7":"",
    "requestFiller8":"",
    "requestFiller1":"",
    "requestFiller2":"",
    "requestFiller10":"",
    "requestFiller5":"",
    "requestFiller6":"",
    "requestFiller3":"",
    "requestFiller4":""
    };
    let body1:any={};
    body1.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body;
    // internalJson.header=JSON.stringify(this.httpOptions1)
    // //console.log(internalJson)
    var rand =  Math.floor((Math.random() * 100) + 1);
    // var encrypted = CryptoJS.AES.encrypt("myString", rand.toString()).toString()
    // //console.log(encrypted);
    // //console.log( CryptoJS.AES.encrypt("abc",rand.toString()).toString());
    body1.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    // //console.log(CryptoJS.AES.decrypt(CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()), rand.toString()).toString(CryptoJS.enc.Utf8))

    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/EmiPemiDetails",JSON.stringify(body1),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
  
   async getFaqDetails(loader){
    //

    // var url = this.finOneApiUrl+'/ibhfl_faqs?include=ibhfl_question,ibhfl_faqid,ibhfl_answer&statecode=0'
    let body:any={};
     
    let internalJson:any={}; 
    const dataKeyy: any = await this.getIVKeySession(loader);
    
    let dataKey = JSON.parse(dataKeyy); 
    var key =  dataKey.Payload.key.toString(CryptoJS.enc.Hex);
    var iv =  dataKey.Payload.iv.toString(CryptoJS.enc.Hex);
    const encrypted = AES.encrypt(JSON.stringify(internalJson), key,{
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    /*body = {
      key: key.toString(CryptoJS.enc.Hex),
      iv: iv.toString(CryptoJS.enc.Hex),
      data: encrypted.toString() // Base64
    }; */
    body = {
      //key: key.toString(CryptoJS.enc.Hex),
      //iv: iv.toString(CryptoJS.enc.Hex),
      uniqueKey:dataKey.Payload.UniqueID,
      data: encrypted.toString() // Base64
    };
    //body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/ibhfl_faqs",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, key.toString(CryptoJS.enc.Hex))
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        // //console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
  // getLightApiData(loader,phoneNumber){
  //   if(!localStorage.getItem("phoneLength")){
  //     phoneNumber = phoneNumber.slice(-10);
  //   }else{
  //     var len=localStorage.getItem("phoneLength")
  //     phoneNumber = phoneNumber.slice(-parseInt(len));
  //   }
    
     
  //   let body:any={};
  //   body.inputstring="";
  //   let internalJson:any={};
  //   internalJson.phoneNumber = phoneNumber;
    
  //   var rand =  Math.floor((Math.random() * 100) + 1);
    
  //   body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
  //   // //console.log(CryptoJS.AES.decrypt(CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()), rand.toString()).toString(CryptoJS.enc.Utf8))

  //   return new Promise(resolve => {
  //     this.http.post(this.commonApiUrl+'/lightapidata',JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
  //        // //console.log(rand.toString(),data.outputstring);
  //       var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
  //       var newData =  data1.toString(CryptoJS.enc.Utf8);
  //       // console.log(newData);
  //       resolve(newData);
  //     }, err => {
  //       loader.dismiss()
        

  //     });
  //   });


   
    
  // }

getLightApiData(loader,phoneNumber,check:any=true){
     
    if(check){
      if(!localStorage.getItem("phoneLength")){
        phoneNumber = phoneNumber.slice(-10);
      }else{
        var len=localStorage.getItem("phoneLength")
        phoneNumber = phoneNumber.slice(-parseInt(len));
      }
    }
     
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    if(check){
      //console.log(phoneNumber,"phoneNumber")
    internalJson.phoneNumber = phoneNumber;
    }else{
      internalJson.cifNumber = phoneNumber;
      //console.log(phoneNumber,"cifNumber")
    }
    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+AES.encrypt(JSON.stringify(internalJson), rand.toString());
    // //console.log(AES.decrypt(AES.encrypt(JSON.stringify(internalJson), rand.toString()), rand.toString()).toString(Utf8))

    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+'/lightapidata',JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(Utf8);
        // console.log(newData);
        resolve(newData);
      }, err => {
        loader.dismiss()
        

      });
    });


   
    
  }  
  
 updatePayment(loader,response,type,token){
     
    let body1:any = {};
    body1.responce=response;
    body1.paymentType=type;
    body1.lan=localStorage.getItem("cc");
    body1.localPaymentResponce=localStorage.getItem("localPaymentResponce");
    body1.userid=localStorage.getItem("mobile");
     
    // var url = this.mpinUrl+'ccs_provisionalmobilestorages/'+mobile

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
     
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
       let httpOptionsWithtoken = {
        headers: new HttpHeaders(
        { 'Authorization': localStorage.getItem('token'),"token":token },
        )
    };
      this.http.post(this.commonApiUrl+"/updatePaymentWeb",JSON.stringify(body),httpOptionsWithtoken).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

  updatePassword(loader,password,mobile){
    ///919987074887
    let body1:any = {};
    body1.ccs_mobilenumber=mobile;
    body1.ibhfl_password=password
     
    // var url = this.mpinUrl+'ccs_provisionalmobilestorages/'+mobile

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    internalJson.mobile = mobile;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/ccs_provisionalmobilestorages",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }
async uploadApi(loader,request,fetchFileData)
{

    let documentdata:any={};
    documentdata.documentdata={};
    let body:any={};
    let internalJson:any={};
    request.docchecklist=[];
    documentdata.documentdata.documentType=fetchFileData.documentType
    documentdata.documentdata.documentName=fetchFileData.name
    documentdata.documentdata.mimeType=fetchFileData.type
    request.docchecklist.push(documentdata);
    internalJson.body = request;
     //console.log(internalJson,"internalJson")
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    let formData = new FormData();
    formData.append("inputstring", btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()));
    formData.append("image", fetchFileData);

    this.httpOptions1 = {
        headers: new HttpHeaders(
          
          {'enctype':'multipart/form-data', 'Authorization': localStorage.getItem("token")?localStorage.getItem("token") :"" },
        
        )
      };

    
    // body.image = fileData
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/documentUploadHomeLoanService",formData,this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
      
    
}


async changeAddressApi(loader,data,fileData,documentData,comments,documentType,header_ibhfl_documentheaderid,header_ibhfl_docid,fetchFileData)
{

    let body1:any={};
    body1.casesr={};
    body1.docchecklist = [];
    let documentdata:any={};
    documentdata.checklist={};
    documentdata.documentdata={};
    let body:any={};
     //console.log("data upload api",data);
    body1.casesr.ccs_addressline2=data.ccs_addressline2;
    body1.casesr.ccs_addressline3=data.ccs_addressline3;
    body1.casesr.ibhfl_stdcode=data.ibhfl_stdcode;
    body1.casesr.ibhfl_customername=data.ibhfl_customername;
    body1.casesr.ibhfl_role=data.ibhfl_role;
    body1.casesr.ccs_addressline1=data.ccs_addressline1;
    body1.casesr.ccs_casecategory=data.ccs_casecategory;
    body1.casesr.ibhfl_pincode=data.ibhfl_pincode;
    body1.casesr.ccs_communicationaddress=data.ccs_communicationaddress;
    body1.casesr.ccs_casedescription=data.ccs_casedescription;
    body1.casesr.ibhfl_addresstypes=data.ibhfl_addresstypes;
    body1.casesr.ibhfl_newemailid=data.ibhfl_newemailid;
    body1.casesr.ccs_casedescription=data.ccs_casedescription;
    body1.casesr.ibhfl_addresstypes=data.ibhfl_addresstypes;
    body1.casesr.ibhfl_city=data.ibhfl_city;
    body1.casesr.ccs_casetype=data.ccs_casetype;
    body1.casesr.ccs_casesubtype=data.ccs_casesubtype;
    body1.casesr.ibhfl_loanaccountnumber1=data.ibhfl_loanaccountnumber1;
    body1.casesr.ibhfl_state=data.ibhfl_state;
    body1.casesr.ibhfl_phone2=data.ibhfl_phone2;
    body1.casesr.ccs_remarksaddress=data.ccs_remarksaddress;
    body1.casesr.ibhfl_phone1=data.ibhfl_phone1;
    body1.casesr.ibhfl_newmobileno=data.ibhfl_newmobileno;
    body1.casesr.customerid=data.customerid;
    body1.casesr.ibhfl_addressline4=data.ibhfl_addressline4;
    body1.casesr.ccs_originatingsource=orignalsourcename;
    body1.ccs_originatingsource=orignalsourcename;
    documentdata.documentdata.comments=comments;
    documentdata.documentdata.documentType=documentType
    documentdata.documentdata.documentName=documentData.name
    documentdata.documentdata.mimeType=documentData.type
    documentdata.checklist.ibhfl_perfiostrigger=false
    documentdata.checklist.header_ibhfl_documentheaderid=header_ibhfl_documentheaderid
    documentdata.checklist.header_ibhfl_docid=header_ibhfl_docid
    documentdata.checklist.ibhfl_passwordprotected=false
    body1.docchecklist.push(documentdata);
   
    // var url=this.mainUrl+"/esb/ibhfl/crmcasesrdocupload/v1/createsranddocupload"

    let internalJson:any={};
    // internalJson.url = url;
    // body1=  {"casesr":{"ccs_addressline2":"CHAVAN NAGAR,DHANKAWADI","ccs_addressline3":".","ibhfl_stdcode":"020","ibhfl_customername":"SWAPNIL RAJU VAIDYA","ibhfl_role":"Applicant","ccs_addressline1":"PLOT NO. 10 ,SR. NO 17\/307,","ccs_casecategory":"CC03","ibhfl_pincode":"411043","ccs_communicationaddress":false,"ibhfl_newemailid":"swapnilvaidya12@gmail.com","ccs_casedescription":"Create case for Edit Address","ibhfl_addresstypes":"OFFICE","ibhfl_city":"22","ccs_casetype":"CT33","ccs_casesubtype":"ST01","ibhfl_loanaccountnumber1":"HHLPUN00418194","ibhfl_state":"28","ibhfl_phone2":"45454545","ccs_remarksaddress":"Create case for Edit Address","ibhfl_phone1":"45454545","ibhfl_newmobileno":"8793356535","customerid":"911636","ibhfl_addressline4":"","ccs_originatingsource":"S011"},"docchecklist":[{"documentdata":{"comments":"Additional Documents","documentType":"Document","documentbody":"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","documentName":"PersonalInfo_140320231139190000.png","mimeType":".png"},"checklist":{"ibhfl_perfiostrigger":false,"header_ibhfl_documentheaderid":"1899f881-fdb5-ea11-a812-000d3a3e02e8","header_ibhfl_docid":"DOCAD01","ibhfl_passwordprotected":false}}],"ccs_originatingsource":"S011"}
    internalJson.body = body1;
     //console.log(internalJson,"internalJson")
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    let formData = new FormData();
    formData.append("inputstring", btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()));
    formData.append("image", fetchFileData);

    this.httpOptions1 = {
        headers: new HttpHeaders(
          
          {'enctype':'multipart/form-data', 'Authorization': localStorage.getItem("token")?localStorage.getItem("token") :"" },
        
        )
      };

    
    // body.image = fileData
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/documentUploadservice",formData,this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
      
    
}
  createPaymentTrasaction(loader,request,token){

    // var url = this.tokenGenUrl+"SaveOnlinePaymentDetailsNew"

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = request;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      let httpOptionsWithtoken = {
      headers: new HttpHeaders(
        { 'Authorization': localStorage.getItem('token'),"token":token },
        )
      };
      this.http.post(this.commonApiUrl+"/createPaymentWeb",JSON.stringify(body),httpOptionsWithtoken).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         console.log("createPaymentWeb",newData)
        resolve(newData);
      }, err => {
        loader.dismiss()
        //console.log(err)
        
      });
    });


    //https://mloans.indiabulls.com/CPS.svc/SaveOnlinePaymentDetailsNew
  }

  branchCity(loader){
    ///919987074887
    let body1:any = {};
    

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    // body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/branchCity",internalJson,this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        // var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        // var newData =  data1.toString(CryptoJS.enc.Utf8);
         
        resolve(data);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
     

  }
  branchLocator(loader,request){
    ///919987074887
    let body1:any = {};
    

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = request;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/branchLocatorByLatLong",body,this.httpOptions1).subscribe((data:any) => {
        resolve(data);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
     

  }
  referAFriends(loader,request){
///919987074887
    // var url = this.mainUrl+"/v6/crm/leads"

    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = request;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/referAFriends",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
         //console.log(newData)
        resolve(newData);
      }, err => {
        loader.dismiss()
        //console.log(err)
        
      });
    });
  }
/************************************New Customer Journey****************************************************/
/*
*
*
*
*
*/
/***********************************************************************************************************/
  
//First function for new customer journey
/*
Function name : CreateLead
Function type : Parameterised
passed Two parameters;
Loader : Objecttype,
request: Object 

*/

  createLead(loader,request){
    let body:any={};body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/createLead",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }

  /*
  Function name : updateLead
  Function type : Parameterised
  passed Two parameters;
  Loader : Objecttype,
  request: Object 

  */
  updateLead(loader,request){
    let body:any={};body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/updateLead",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }
  /*
  Function name : viewLeadById
  Function type : Parameterised
  passed Two parameters;
  Loader : Objecttype,
  request: Object 

  */
  viewLeadById(loader,request){
    let body:any={};body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/viewLeadById",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }


  getCityByPincode(loader,request){
    let body:any={};body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/getStateandCityBycode",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }
   /*
  Function name : getLoanType
  Function type : Parameterised
  passed Two parameters;
  Loader : Objecttype,
  request: Object 

  */
  getLoanType(loader,request){
    let body:any={};
    request.productcode = localStorage.getItem('loantype')
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/getLoanType",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }

   propertyType(loader,request){
    let body:any={};
     
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/propertyType",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }

 getPurpose(loader,request){
    let body:any={};
     
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/getPurposes",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }

  cityMaster(loader,request){
    let body:any={};
    // request.productcode = localStorage.getItem('loantype')
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/cityMaster",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }

  getEmployers(loader,request){
    let body:any={};
    // request.productcode = localStorage.getItem('loantype')
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/getEmployers",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }

  getDocList(loader,request){
    console.log(request);
    let body:any={};
    // request.productcode = localStorage.getItem('loantype')
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/docList",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }


  panVerification(loader,request){
    let body:any={};
    // request.productcode = localStorage.getItem('loantype')
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/panVerification",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }
  getNriZipcode(loader,request){
    let body:any={};
    // request.productcode = localStorage.getItem('loantype')
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/nriCityName",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }
  checkLatestVersion(loader,request){
    let body:any={};
    // request.productcode = localStorage.getItem('loantype')
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/checkLatestVersion",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }
  
 appointmentmanagement(loader,request){
    let body:any={};
    // request.productcode = localStorage.getItem('loantype')
    body.inputstring="";let internalJson:any={};
    internalJson.body = request;var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      
      this.http.post(this.commonApiUrl+"/appointmentmanagement",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        resolve(newData);
      }, err => {
        loader.dismiss()
      });
    });
  }
  
/**************************Getdocumenttypemaster**********************************/

   getDocumentTypeMaster(loader) {
    // var url = this.finOneApiUrl+'/ibhfl_countrydialingcodes?statecode=0&orderby=ibhfl_ordernumber'
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/TypeDocument",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        console.log(newData,"getDocumentTypeMaster");
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  }

/*********************************************************************************/  
/********************************************/
  postMaritalSatus(loader,request){
  let body1:any = {};
    
    body1=request
     
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    // let formData = new FormData();
    // formData.append("inputstring", btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()));
    // formData.append("image", fetchFileData);

    // this.httpOptions1 = {
    //     headers: new HttpHeaders(
          
    //       {'enctype':'multipart/form-data', 'Authorization': localStorage.getItem("token")?localStorage.getItem("token") :"" },
        
    //     )
    //   };
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/UpdateMaritalStatus",body).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
          
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  
  }

  


  postUploadDocumentchecklist(loader,request,fetchFileData){
  let body1:any = {};
    
    body1=request
     
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    let formData = new FormData();
    formData.append("inputstring", btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()));
    formData.append("image", fetchFileData);

    this.httpOptions1 = {
        headers: new HttpHeaders(
          
          {'enctype':'multipart/form-data', 'Authorization': localStorage.getItem("token")?localStorage.getItem("token") :"" },
        
        )
      };
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/uploadDocumentchecklist",formData,this.httpOptions1).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
          
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  
  }
  postDetdocumentchecklist(loader,request){
  let body1:any = {};
    
    body1=request
     
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    // let formData = new FormData();
    // formData.append("inputstring", btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString()));
    // formData.append("image", fetchFileData);

     
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/getdocumentchecklist",body).subscribe((data:any) => {
         // //console.log(rand.toString(),data.outputstring);
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
          
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  
  }

  /******************Chatboat******************/
  postChatboat(loader,request){

    
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    internalJson.body=request;
    //internalJson.code = '01005';

    var rand =  Math.floor((Math.random() * 100) + 1);
    
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/chatBoat",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
         
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        
        resolve(newData);
      }, err => {
        loader.dismiss()
        
      });
    });    
  }
  /**********************End Chat**************/
/*****************************/

  getIVKeySession(loader){
  let body:any={};
  body.inputstring="";
  let internalJson:any={};
   
  
  var rand =  Math.floor((Math.random() * 100) + 1);
  // const key  =  CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex).slice(0, 32);
  // const iv   =  CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex).slice(0, 16);; 
  const key = CryptoJS.lib.WordArray.random(32); // 32 bytes
  const iv  = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(internalJson), key.toString(CryptoJS.enc.Hex), {
    iv: iv.toString(CryptoJS.enc.Hex),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

 
                               

  const payload = {
    key: key.toString(CryptoJS.enc.Hex),
    iv: iv.toString(CryptoJS.enc.Hex),
    data: encrypted.toString() // Base64
  }; 
  return new Promise(resolve => {
    this.http.post(this.commonApiUrl+"/getIVKeySession",JSON.stringify(payload),this.httpOptions1).subscribe((data:any) => {
       var data1 = CryptoJS.AES.decrypt(data.outputstring, key.toString(CryptoJS.enc.Hex), {
                                iv: iv.toString(CryptoJS.enc.Hex),
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7
                              });
      var newData =  data1.toString(Utf8);;
       
      resolve(newData);
    }, err => {
      loader.dismiss()
       
    });
  });
}

generatenoc (loader,request) {
  let body1:any = {};
    
    body1=request
     
    let body:any={};
    body.inputstring="";
    let internalJson:any={};
    // internalJson.url = url;
    //body1.ibhfl_customerloanid =localStorage.getItem("ibhfl_customerloanid");
    internalJson.body = body1;
    var rand =  Math.floor((Math.random() * 100) + 1);
    body.inputstring = btoa(rand.toString())+'~'+CryptoJS.AES.encrypt(JSON.stringify(internalJson), rand.toString());
    return new Promise(resolve => {
      this.http.post(this.commonApiUrl+"/generateNoc",JSON.stringify(body),this.httpOptions1).subscribe((data:any) => {
        
        var data1 = CryptoJS.AES.decrypt(data.outputstring, rand.toString())
        var newData =  data1.toString(CryptoJS.enc.Utf8);
        console.log(newData,"generateNoc");  
        resolve(newData);
      }, err => {
        loader.dismiss()
        // alert("Invalid Credencials,Please try again!"+JSON.stringify(err));
      });
    });
  
}  
}



// WEBPACK FOOTER //
// ./src/providers/common/common.ts